import { render, staticRenderFns } from "./modal-suggest-service.vue?vue&type=template&id=512cf2b4&scoped=true"
import script from "./modal-suggest-service.vue?vue&type=script&lang=js"
export * from "./modal-suggest-service.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512cf2b4",
  null
  
)

export default component.exports